module.exports = __webpack_public_path__ + "static/media/grade5-S__ bg.5bc7f787.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/grade5-S__ bg.jpg
// module id = 2270
// module chunks = 0